import { render, staticRenderFns } from "./view-incident-details.vue?vue&type=template&id=003de47a&"
import script from "./view-incident-details.vue?vue&type=script&lang=js&"
export * from "./view-incident-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports